import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const GetProductModalSubstituteProductsDocument = gql`
  query GetProductModalSubstituteProducts($productId: Int!) {
    product(id: $productId) {
      id
      substituteProducts {
        unpaginated {
          id
          substitute {
            id
            image
            brand
            itemDescription
            itemSize
            itemMeasure
            itemPackName
            concatenatedSellUnit
            itemSellQuantity
            owner {
              id
            }
          }
        }
        totalCount
      }
    }
  }
` as unknown as DocumentNode<
  Types.GetProductModalSubstituteProductsQuery,
  Types.GetProductModalSubstituteProductsQueryVariables
>
